import { actions as uiActions, selectors as uiSelectors } from 'ducks/ui'
import { actions as operationActions } from 'ducks/uiOperations'
import { actions as formActions } from 'ducks/form'
import { selectors as grnSelector, actions as grnActions } from 'ducks/supplierEnquiry/activity/grns'
import { fetch } from 'api/supplierEnquiry/activity/grns'
import { actions as filterActions, selectors as filterSelectors } from 'ducks/common/filters'
import { selectors as supplierSelectors } from 'ducks/supplierEnquiry/supplier';


export const mapStateToProps = state => {
  const params = new URLSearchParams(location.search);

  return {
    gridName: 'SupplierActivityGRNs',
    columnDefs: grnSelector.columns(state),
    isCustomerLookUpOpen: uiSelectors.isCustomerLookUpOpen(state),
    gridOptions: grnSelector.gridOptions(state),
    filterRow: grnSelector.filterRow(state),
    selectedFilters: grnSelector.selectedFilters(state),
    appliedFilters: grnSelector.filterRow(state) && filterSelectors.getFilters(state, grnSelector.filterRow(state).formName),
    reqParams: (supplierSelectors.selected(state) || params.get('Supplier'))
      &&
    {
      SupplierId: (supplierSelectors.selected(state) && supplierSelectors.selected(state).Supplier) || params.get('Supplier')
    },
    apiMethod: supplierSelectors?.selected(state)?.Supplier || params?.get('Supplier') ? fetch : () => Promise.resolve(null)
  }
};

export const actions = {
  changeSelectedTab: uiActions.changeSelectedTab,
  changeOperationMode: operationActions.changeOperationMode,
  getFormSchema: formActions.search,
  changeSelectedForm: formActions.setSelected,
  setSelectedOrderLine: grnActions.setSelected,
  applyFilters: filterActions.applyFilters
}
